const GarlicBreadsAndDips = [
  {
    itemName: "Garlic Breadsticks",
    description:
      "Baked to perfection. Your perfect pizza partner! Tastes best with dip.",
    price: "109",
  },
  {
    itemName: "Veg Parcel",
    description:
      "Snacky bites! Pizza rolls with paneer & creamy harissa sauce.",
    price: "49",
  },
  {
    itemName: "Cheesy Dip",
    description:
      "An all-time favorite with your Garlic Breadsticks & Stuffed Garlic Bread for a Cheesy indulgence.",
    price: "30",
  },
  {
    itemName: "GClassic Stuffed Garlic Bread",
    description:
      "Freshly baked garlic bread with cheese, juicy corn & tangy jalapeno.",
    price: "149",
  },
  {
    itemName: "Taco Mexicana Veg",
    description:
      "Truly irresistible! Crispy taco with veg patty & creamy harissa",
    price: "129",
  },
  {
    itemName: "Harissa Dip",
    description:
      "A spicy & peppery pizza dip which can help you add the right amount of spiciness to your favorite pizza slices..",
    price: "49",
  },
  {
    itemName: "Basil Pesto Dip",
    description:
      "Your perfect pizza partner! Savour your pizza slices with this new rich, herby & salty dip with the goodness of basil leaves &...",
    price: "49",
  },
  {
    itemName: "Taco Mexicana-Veg (Single)",
    description:
      "Truly irresistible! Crispy taco with a delicious veg patty & creamy sauce.",
    price: "79",
  },
];

const lunchFeast = [
  {
    itemName: "Farmhouse",
    description:
      "Delightful combination of onion, capsicum, tomato & grilled mushroom.",
    price: "79",
  },
  {
    itemName: "Peppy Paneer",
    description:
      "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika.",
    price: "79",
  },
  {
    itemName: "Margherita",
    description: "Classic delight with 100% real mozzarella cheese.",
    price: "79",
  },
  {
    itemName: "Veggie Paradise",
    description:
      "The awesome foursome! Golden corn, black olives, capsicum, red paprika.",
    price: "79",
  },
  {
    itemName: "Indi Tandoori Paneer",
    description:
      "It is hot. It is spicy. It is oh-so-Indian. Tandoori paneer with capsicum, red paprika & mint mayo.",
    price: "79",
  },
  // {
  //   itemName: "Veg Extravaganza",
  //   description:
  //     "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese.",
  //   price: "79",
  // },
  // {
  //   itemName: "Corn n Cheese Paratha Pizza",
  //   description:
  //     "A crazy fusion like never before. A delicious fusion of corn stuffed paratha and cheesy pizza..",
  //   price: "79",
  // },
  // {
  //   itemName: "Mexican Green Wave",
  //   description:
  //     "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
  //   price: "79",
  // },
  // {
  //   itemName: "Cheese n Corn",
  //   description: "A delectable combination of sweet & juicy golden corn.",
  //   price: "79",
  // },
];

const cheeseVolcano = [
  {
    itemName: "Cheese Volcano Veg Paradise",
    description:
      "Centre loaded with Molten Cheese & topped with Golden Corn, Black Olives, Capsicum & Red Paprika ",
    price: "79",
  },
  {
    itemName: "Cheese Volcano Farmhouse",
    description:
      "Centre loaded with Molten Cheese & topped with Onion, Capsicum, Tomato & Grilled Mushroom ",
    price: "79",
  },
  {
    itemName: "Cheese Volcano Peppy Paneer",
    description:
      "Centre loaded with Molten Cheese & topped with peppy Paneer, Capsicum & Red Paprika *Contains non-edible container under...",
    price: "79",
  },
  {
    itemName: "Corn & Cheese Volcano",
    description:
      "Centre loaded with Molten Cheese & topped with juicy Golden Corn *Contains non-edible container under the Pizza.",
    price: "79",
  },
];

export const bestSellers = [
  {
    id: "100",
    itemName: "Margherita",
    description: "Classic delight with 100% real mozzarella cheese.",
    price: 250,
    imageSource: "/photos/bestsellers/marghareeta.png",
    totalValue: 250,
    quantity: 1,
  },
  {
    id: "101",
    itemName: "Farmhouse",
    description:
      "Delightful combination of onion, capsicum, tomato & grilled mushroom.",
    price: 249,
    imageSource: "/photos/bestsellers/farmhouse.png",
    totalValue: 249,
    quantity: 1,
  },
  {
    id: "102",
    itemName: "Veg Extravaganza",
    description:
      "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese.",
    price: 325,
    imageSource: "/photos/bestsellers/extravegenza.png",
    totalValue: 325,
    quantity: 1,
  },

  {
    id: "103",
    itemName: "Peppy Paneer",
    description:
      "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika.",
    price: 400,
    imageSource: "/photos/bestsellers/peppypanner.png",
    totalValue: 400,
    quantity: 1,
  },
  {
    id: "104",
    itemName: "Veggie Paradise",
    description:
      "The awesome foursome! Golden corn, black olives, capsicum, red paprika.",
    price: 375,
    imageSource: "/photos/bestsellers/paradise.png",
    totalValue: 250,
    quantity: 1,
  },
  // {
  //   itemName: "Golden Corn",
  //   description: "Sweet & juicy golden corn for that lipsmacking taste.",
  //   price: "79",
  // },
  // {
  //   itemName: "Onion",
  //   description: "Our classic Pizza Mania topped with crunchy Onions.",
  //   price: "79",
  // },
  // {
  //   itemName: "Paneer & Capsicum with Videshi Hot Sauce",
  //   description:
  //     "Internationally inspired Hot sauce to cater your spice cravings loaded with juicy Paneer and crisp Capsicum..",
  //   price: "79",
  // },
  // {
  //   itemName: "Paneer, Onion & Capsicum with Desi Makhani Sauce",
  //   description:
  //     "Authentic Indian Flavor of Makhani Sauce loaded with juicy Paneer, crisp Capsicum and crunchy onion..",
  //   price: "79",
  // },
];
